import { Payload } from "@neworbit/redux-helpers";

import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { ohCaseTaskApi } from "../crud/ohCase/ohCaseTaskApi";

import { TaskType, taskTypeFilters, TaskTypeFilters } from "../task/model";

import { LOAD_TASK_TYPES_SUCCESS } from "./actiontypes";
import { TasksApi } from "./tasksApi";

export type TaskAction =
    ({ type: typeof LOAD_TASK_TYPES_SUCCESS } & Payload<TaskType[]>);

export const loadTaskTypesSuccess = (payload: TaskType[]): TaskAction => ({
    payload,
    type: LOAD_TASK_TYPES_SUCCESS
});

export function loadTaskTypes(customerId: string, caseId: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadTaskTypes", ohCaseTaskApi.assignableTasks(customerId, caseId));
        dispatch(loadTaskTypesSuccess(result));
    };
}

export function loadAllTaskTypes(filters: TaskTypeFilters = taskTypeFilters) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadTaskTypes", new TasksApi().getAllTaskTypes(filters));
        dispatch(loadTaskTypesSuccess(result));
    };
}

export function updateTaskTypes(taskType: TaskType) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "updateTaskTypes", new TasksApi().updateTaskType(taskType));
    };
}
